var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-[8px] bg-[#FFF4ED] text-[#F95E16] tetx-[14px] w-fit py-[0.25rem] px-[0.625rem]"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }